module.exports = __webpack_public_path__ + "img/763B28_D0BDB8_ADA39E_1E1D1D-256px.76158e70.png";